export default "__VITE_ASSET__B3Cx7l2W__"